import { render, staticRenderFns } from "./DecimalPlacesStepper.vue?vue&type=template&id=5c0608f0&scoped=true&"
import script from "./DecimalPlacesStepper.vue?vue&type=script&lang=ts&"
export * from "./DecimalPlacesStepper.vue?vue&type=script&lang=ts&"
import style0 from "./DecimalPlacesStepper.vue?vue&type=style&index=0&id=5c0608f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0608f0",
  null
  
)

export default component.exports